import { inject, Injectable, signal } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { LinkApi } from '../APIs/link.api';
import { LinkEntity } from '../entities/link.entitty';
import { DomainTranslateService } from '../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class LinkController {
    // * [Data company]
    public links = signal<LinkEntity[]>([]);

    // * [API]
    private _api = inject(LinkApi);

    // * [Injects]
    private _utilService = inject(UtilService);
    private _i18n = inject(DomainTranslateService);

    /**
     * Get all links
     * @returns LinkEntity[]
     */
    public getAll(): Observable<LinkEntity[]> {
        return this._api.getAll().pipe(
            map(response => {
                this.links.set(response.body);
                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(error, this._i18n.instant('domain.common.errors.fetchLinks'))
            )
        );
    }
}
